import React, { useEffect, useState, useRef } from "react";
import meetingPlusWhiteLogoForDashBoard from "../../../assets/images/minutes-vault-white-logo.png";
import meetingLogo from "../../../assets/images/meeting_logo.png";
import createmeeting from "../../../assets/images/create-meeting.svg";
import meeting2Logo from "../../../assets/images/meeting2.svg";
import actionLogo from "../../../assets/images/clipboard_839860.png";
import emailTemplateLogo from "../../../assets/images/emailTemplate.png";
import settingLogo from "../../../assets/images/setting.png";
import manageLogo from "../../../assets/images/manage.png";
import logLogo from "../../../assets/images/activity.png";
import userManual from "../../../assets/images/usermanualbook.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../node_modules/axios/index";
import "./Sidebar.css";
import { useSelector, useDispatch } from "react-redux";
import {
  closeSidebar,
  openSidebar,
} from "../../../redux/actions/commonActions/commonAction";
import { setOrganizationData } from "../../../redux/actions/organizationAction/OrganizationAction";
import { setCreateNewMeetingPage } from "../../../redux/actions/meetingActions/MeetingAction";
import { handleApiError } from "../../../helpers/errorResponseHelper";
const Sidebar = React.memo((props) => {
  const dispatch = useDispatch();
  const commonData = useSelector((state) => state.common);
  const employeeData = useSelector((state) => state.user);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isManageMenuOpen, setIsManageMenuOpen] = useState(false);
  const [isLogsMenuOpen, setIsLogsMenuOpen] = useState(false);
  const [isSettingMenuOpen, setIsSettingMenuOpen] = useState(false);

  const [loading, setIsLoading] = useState(false);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const authData = useSelector((state) => state.auth);
  const organizationId = userData?.organizationId;
  const accessToken = localStorage.getItem("accessToken");
  const organizationData = useSelector((state) => state.organization);
  const paths = [
    "/alerts",
    "/meeting-room",
    "/unit",
    "/designation",
    "/department",
    "/organization",
    "/configuration",
    "/employee",
    "/hosting-details",
    "/smtp-configuration",
  ];
  const navigate = useNavigate();
  const location = useLocation();
  const sidebarRef = useRef(null);
  let currentPaths = location.pathname;
  useEffect(() => {
    paths.includes(currentPaths)
      ? setIsSubMenuOpen(true)
      : setIsSubMenuOpen(false);
  }, [currentPaths]);
  useEffect(() => {
    fetchOrganization();
  }, []);

  const fetchOrganization = async (id) => {
    try {
      setIsLoading(true);
      if (accessToken && !authData.isInValidUser) {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/V1/organization/viewSingleOrganization/${organizationId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
            },
          }
        );
        if (response.data.success) {
          setIsLoading(false);
          dispatch(setOrganizationData(response.data.data));
        }
        return response.data;
      }
    } catch (error) {
      if (handleApiError(error)) return;
    }
  };

  const handleLinkClick = (event, path, state = {}) => {
    if (event.ctrlKey || event.metaKey) {
      window.open(path, "_blank", "noopener,noreferrer");
    } else {
      navigate(path, { state });
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        dispatch(closeSidebar()); // Close the sidebar
      }
    }
    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dispatch]);
  const handleClick = (event) => {
    //     alert(1)
    if (event.ctrlKey) {
      event.preventDefault(); // Prevents opening in new tab
      event.stopPropagation(); // Prevents bubbling up if needed

      return;
    }

    dispatch(
      setCreateNewMeetingPage({
        status: true,
        isClearingleMeetingDetails: false,
      })
    );
  };
  return (
    <div
      ref={sidebarRef}
      className={commonData?.sidebarStatus ? "sidebar-open-now" : ""}
    >
      <div className="sidebar ">
        <div className="sidebar-close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="#ffff"
            className="bi bi-x"
            viewBox="0 0 16 16"
            onClick={() => dispatch(closeSidebar())}
          >
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
          </svg>
        </div>
        <div className="mt-4 top-logo">
          <Link to="/meeting-list">
            <div className="ntspl-logo">
              {organizationData?.organizationData?.dashboardLogo ? (
                <img src={organizationData?.organizationData?.dashboardLogo} />
              ) : (
                <img src={meetingPlusWhiteLogoForDashBoard} />
              )}
            </div>
          </Link>
        </div>

        <ul className="sidebar-content">
          <div className="create-meet-sidebar">
            <Link
              to="/create-meeting?new=true"
              state={{ isNewMeeting: true }}
              className="link"
              onClick={handleClick} // Using the handleClick to detect key press
            >
              <li
                onClick={() => dispatch(closeSidebar())}
                className={
                  currentPaths == "/create-meeting" ? "active-menu" : ""
                }
              >
                <img className="meeting-logo" src={createmeeting} />
                Create Meeting
              </li>
            </Link>
          </div>

          <Link
            to="/meeting-list"
            className="link"
            onClick={() => {
              setIsSubMenuOpen(false);
            }}
          >
            <li
              className={currentPaths == "/meeting-list" ? "active-menu" : ""}
              onClick={() => dispatch(closeSidebar())}
            >
              <img className="meeting-logo" src={meetingLogo} />
              Meetings
            </li>
          </Link>

          <Link
            to="/action-list"
            className="link"
            onClick={() => {
              setIsSubMenuOpen(false);
            }}
          >
            <li
              className={currentPaths == "/action-list" ? "active-menu" : ""}
              onClick={() => dispatch(closeSidebar())}
            >
              <img className="clipboard" src={actionLogo} />
              Actions
            </li>
          </Link>

          {employeeData?.userData?.isAdmin ? (
            <Link
              to=""
              className="link"
              onClick={(event) => event.preventDefault()}
            >
              <li
                className={currentPaths == "manage" ? "active-menu" : ""}
                onClick={() => {
                  setIsManageMenuOpen(!isManageMenuOpen);
                  setIsLogsMenuOpen(false); // close Logs if Manage is opened
                  setIsSettingMenuOpen(false);
                  dispatch(openSidebar());
                }}
              >
                <img className="clipboard" src={manageLogo} />
                <div className="manage-dropdown">
                  <div>Manage</div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#ffff"
                      className="bi bi-caret-down-fill drop-icon"
                      viewBox="0 0 16 16"
                    >
                      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                    </svg>
                  </div>
                </div>
              </li>
              {isManageMenuOpen ? (
                <ul
                  className="sub-setting"
                  onClick={() => {
                    dispatch(closeSidebar());
                  }}
                >
                  <li
                    className={
                      currentPaths === "/organization" ? "active-menu" : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/organization", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Organization
                  </li>
                  <li
                    className={currentPaths === "/unit" ? "active-menu" : ""}
                    onClick={(event) =>
                      handleLinkClick(event, "/unit", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Units
                  </li>
                  <li
                    className={
                      currentPaths === "/department" ? "active-menu" : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/department", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Departments
                  </li>
                  <li
                    className={
                      currentPaths === "/designation" ? "active-menu" : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/designation", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Designations
                  </li>
                  <li
                    className={
                      currentPaths === "/employee" ? "active-menu" : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/employee", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Employees
                  </li>
                  <li
                    className={
                      currentPaths === "/meeting-room" ? "active-menu" : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/meeting-room", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Meeting Rooms
                  </li>
                </ul>
              ) : null}
            </Link>
          ) : null}

          {employeeData?.userData?.isAdmin ? (
            <Link
              to=""
              className="link"
              onClick={(event) => event.preventDefault()}
            >
              <li
                className={currentPaths == "manage" ? "active-menu" : ""}
                onClick={() => {
                  setIsSettingMenuOpen(!isSettingMenuOpen);
                  setIsManageMenuOpen(false);
                  setIsLogsMenuOpen(false);
                  dispatch(openSidebar());
                }}
              >
                <img className="clipboard" src={settingLogo} />
                <div className="manage-dropdown">
                  <div>Settings</div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#ffff"
                      className="bi bi-caret-down-fill drop-icon"
                      viewBox="0 0 16 16"
                    >
                      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                    </svg>
                  </div>
                </div>
              </li>
              {isSettingMenuOpen ? (
                <ul
                  className="sub-setting"
                  onClick={() => {
                    dispatch(closeSidebar());
                  }}
                >
                  <li
                    className={currentPaths === "/alerts" ? "active-menu" : ""}
                    onClick={(event) =>
                      handleLinkClick(event, "/alerts", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Alerts
                  </li>
                  <li
                    className={
                      currentPaths === "/configuration" ? "active-menu" : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/configuration", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Configuration
                  </li>
                  <li
                    className={
                      currentPaths === "/hosting-details" ? "active-menu" : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/hosting-details", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - Hosting
                  </li>
                  <li
                    className={
                      currentPaths === "/smtp-configuration"
                        ? "active-menu"
                        : ""
                    }
                    onClick={(event) =>
                      handleLinkClick(event, "/smtp-configuration", {
                        camefromPreviousPage: true,
                      })
                    }
                    style={{ cursor: "pointer" }}
                  >
                    - SMTP Set Up
                  </li>
                </ul>
              ) : null}
            </Link>
          ) : null}

          {employeeData?.userData?.isAdmin ? (
            <Link
              to=""
              className="link"
              onClick={(event) => event.preventDefault()}
            >
              <li
                className={currentPaths === "manage" ? "active-menu" : ""}
                onClick={() => {
                  setIsLogsMenuOpen(!isLogsMenuOpen);
                  setIsManageMenuOpen(false);
                  setIsSettingMenuOpen(false);
                  dispatch(openSidebar());
                }}
                style={{ cursor: "pointer" }}
              >
                <img className="clipboard" src={logLogo} alt="Logs" />
                <div className="manage-dropdown">
                  <div>Logs</div>
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="#ffff"
                      className="bi bi-caret-down-fill drop-icon"
                      viewBox="0 0 16 16"
                    >
                      <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                    </svg>
                  </div>
                </div>
              </li>

              {isLogsMenuOpen && (
                <ul
                  className="sub-setting"
                  onClick={() => {
                    dispatch(closeSidebar());
                  }}
                >
                  <li
                    className={
                      currentPaths === "/email-activity-logs"
                        ? "active-menu"
                        : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={(e) =>
                      handleLinkClick(e, "/email-activity-logs", {
                        camefromPreviousPage: true,
                      })
                    }
                  >
                    - Email Logs
                  </li>
                  <li
                    className={
                      currentPaths === "/activity-logs" ? "active-menu" : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={(e) =>
                      handleLinkClick(e, "/activity-logs", {
                        camefromPreviousPage: true,
                      })
                    }
                  >
                    - Activity Logs
                  </li>
                </ul>
              )}
            </Link>
          ) : (
            <Link
              to="/email-activity-logs"
              className="link"
              onClick={(event) =>
                handleLinkClick(event, "/email-activity-logs")
              }
              style={{ cursor: "pointer" }}
            >
              <li
                onClick={() => dispatch(closeSidebar())}
                className={
                  currentPaths == "/email-activity-logs" ? "active-menu" : ""
                }
              >
                <img className="meeting-logo" src={logLogo} />
                Email Logs
              </li>
            </Link>
          )}

          {employeeData?.userData?.isAdmin ? (
            <Link
              to="/email-template"
              className="link"
              onClick={() => {
                setIsSubMenuOpen(false);
              }}
            >
              <li
                className={
                  currentPaths == "/email-template" ? "active-menu" : ""
                }
                onClick={() => dispatch(closeSidebar())}
              >
                <img className="clipboard" src={emailTemplateLogo} />
                Email Template
              </li>
            </Link>
          ) : null}

          <Link
            to="https://manual.minutesvault.com/user/"
            className="link"
            target="_blank"
            onClick={() => {
              setIsSubMenuOpen(false);
            }}
          >
            <li>
              <img className="toDoList" src={userManual} />
              User Manual
            </li>
          </Link>
        </ul>

        <img className="meeting-img" src={meeting2Logo} alt="" />
      </div>
    </div>
  );
});

export default Sidebar;
